if (!customElements.get("variant-radios")) {
  class VariantRadios extends HTMLElement {
    constructor() {
      super();
      this.quickViewMode = this.dataset.quickViewMode;
      this.productParentElement = this.closest(`[data-section][data-product]`);
      this.dataset.section =
        this.dataset.section || this.productParentElement.dataset.section;
      this.dataset.product = this.productParentElement.dataset.product;
      this.fieldsets = [...this.querySelectorAll("fieldset")];
      this.qtyInput = this.productParentElement.querySelector("quantity-input");
      this.productButtons =
        this.productParentElement.querySelectorAll("product-buttons");
      this.productForms =
        this.productParentElement.querySelectorAll("product-form");
      this.stickyAtcs =
        this.productParentElement.querySelectorAll("sticky-atc");
      this.outputs =
        this.productParentElement.querySelectorAll("._selectedOption");
      this.stickyOutput = document.querySelector('._stickyOutput');
      this.stickyImageOutput = document.querySelector('._stickyImageOutput');
      this.addEventListener("change", this.onVariantChange);
      this.dataset.family && this.fetchFamilyColors();
      this.quantitySelector =
        this.productParentElement.querySelector("quantity-input");

      if (
        window.location.href.includes("?") ||
        window.location.href.includes("&")
      ) {
        this.urlSearchParams = window.location.href
          .replace(this.dataset.url, "")
          .replace(window.location.origin, "");
      } else {
        this.urlSearchParams = "";
      }

      this.handleFirstClick();
    }

    connectedCallback() {
      this.addEventListener("change", this.onVariantChange);
      this.fieldsets.forEach((fieldset) => {
        this.updateVariantsBasedOn(fieldset);
      });
    }

    handleFirstClick() {}

    onVariantChange(e) {
      this.updateVariantSelectedState(true);
      this.updateOptions();
      this.updateOutputs();
      this.updateVariantsBasedOn(e.target.closest("fieldset"));
      this.updateMasterId();
      this.updateStickyOutput();
      this.handleAvailabilityStates();
      this.removeErrorMessage();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateMedia(e);
      this.syncOthers();
    }

    isAllVariantsSelected() {
      return this.fieldsets.every((fieldset) =>
        [...fieldset.elements].some((element) => element.checked)
      );
    }

    updateVariantSelectedState(boolean) {
      this.productParentElement.dataset.variantSelected = boolean;
    }

    updateOutputs() {
      this.outputs.forEach((output) => {
        output.innerHTML = this.options[output.dataset.index];
      });
    }

    updateStickyOutput() {
      if(!this.stickyOutput) return;
      this.stickyOutput.innerHTML = this.currentVariant.title
      this.stickyImageOutput.src = this.currentVariant.featured_image?.src
     }

    updateOptions() {
      this.options = this.fieldsets.map((fieldset) => {
        if (![...fieldset.elements].find((radio) => radio.checked)) return "";
        return [...fieldset.elements].find((radio) => radio.checked).value;
      });
    }

    syncOthers() {
      this.variantRadiosArray =
        this.productParentElement.querySelectorAll(`variant-radios`);

      this.variantRadiosArray.forEach((variantRadios) => {
        variantRadios
          .querySelectorAll("fieldset")
          .forEach((fieldset, index) => {
            [...fieldset.elements]
              .find((radio) => {
                return radio.value === this.options[index];
              })
              .click();
          });
      });
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
      this.quantitySelector.dataset.id = this.currentVariant.id;
    }

    updateVariantsBasedOn(baseFieldset = this.fieldsets[0]) {
      if (baseFieldset == null) {
        baseFieldset = this.fieldsets[0];
      }

      // Handle single option variants
      if (this.fieldsets.length === 1) {
        [...baseFieldset.elements].forEach((radio) => {
          const variant = this.getVariantData().find(
            (variant) => variant.options[0] === radio.value
          );
          radio.setAttribute("found", variant ? "true" : "false");
          radio.setAttribute("available", variant?.available || false);
        });
        return;
      }

      // if the function is not triggered via event, take the first checked element of the first fieldset
      const baseFieldsetValue =
        [...baseFieldset.elements].find((radio) => radio.checked)?.value ||
        [...baseFieldset.elements][0].value;

      // if the variant that triggered change is in the last variant option
      const baseFieldsetIndex = this.fieldsets.findIndex(
        (fieldset) => fieldset === baseFieldset
      );
      if (baseFieldsetIndex + 1 === this.fieldsets.length) return;

      const filteredVariants = this.getVariantData().filter((variant) => {
        return variant.options[baseFieldsetIndex] === baseFieldsetValue;
      });
      this.fieldsets.forEach((fieldset, index) => {
        if (fieldset === baseFieldset) return;

        let handleUnavailableSelects = false;

        [...fieldset.elements].forEach((radio) => {
          radio.setAttribute("available", "false");
          radio.setAttribute("found", "false");

          let variantIndex = filteredVariants.findIndex(
            (variant) => variant.options[index] === radio.value
          );
          if (variantIndex >= 0) {
            radio.setAttribute(
              "found",
              filteredVariants[variantIndex] ? "true" : "false"
            );
            radio.setAttribute(
              "available",
              filteredVariants[variantIndex].available
            );
          } else if (radio.checked) {
            handleUnavailableSelects = true;
          }
        });
        if (handleUnavailableSelects) {
          this.handleUnavailableSelects();
        }
      });
    }

    updateMedia(e) {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      this.productParentElement
        .querySelector(
          `slider-thumbnails [data-media-id="${this.currentVariant.featured_media.id}"]`
        )
        ?.click();
    }

    updateURL() {
      if (
        !this.quickViewMode ||
        !this.currentVariant ||
        this.dataset.updateUrl === "false" ||
        !window.location.pathname.includes("/products/") ||
        !this.dataset.section.includes("product-main")
      )
        return;

      if (this.urlSearchParams.length > 0) {
        if (this.urlSearchParams.includes("variant=")) {
          let regex = /(variant=[0-9])\w+/g;
          const urlVariantParams = this.urlSearchParams.replace(
            regex,
            `variant=${this.currentVariant.id}`
          );
          window.history.replaceState(
            {},
            "",
            `${this.dataset.url}${urlVariantParams}`
          );
        } else {
          window.history.replaceState(
            {},
            "",
            `${this.dataset.url}${this.urlSearchParams}&variant=${this.currentVariant.id}`
          );
        }
      } else {
        window.history.replaceState(
          {},
          "",
          `${this.dataset.url}?variant=${this.currentVariant.id}`
        );
      }
    }

    updateShareUrl() {
      const shareButton = document.getElementById(
        `Share-${this.dataset.section}-${this.dataset.product}`
      );
      if (!shareButton) return;
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }

    updateVariantInput() {
      this.productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;

      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
      let productInfo = this.productParentElement.querySelectorAll(
        `[data-variant-dynamic]`
      );
      if (!productInfo) return;

      productInfo.forEach((item) => item.classList.add("opacity-20"));
      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
      )
        .then((response) => response.text())
        .then((responseText) => {
          let htmlString = responseText;
          // find and replace the 'keep' and 'remove' elements in fetched data. Like 'form' attributes.
          this.productParentElement
            .querySelectorAll("[data-variant-dynamic]")
            .forEach((element, index) => {
              if (element.dataset.keep) {
                const kept = JSON.parse(element.dataset.keep);
                Object.keys(kept).forEach((key) => {
                  const value = kept[key];
                  htmlString = replaceHTMLAttributes(responseText, key, value);
                });
              }

              if (element.dataset.remove) {
                const removeArray = element.dataset.remove.split(",");
                removeArray.forEach((item) => {
                  htmlString = removeHTMLAttributes(htmlString, item);
                });
              }
            });

          const html = new DOMParser().parseFromString(htmlString, "text/html");

          this.productParentElement
            .querySelectorAll("[data-variant-dynamic]")
            .forEach((element, index) => {
              const id = element.dataset.variantDynamic;
              const destinations = this.productParentElement.querySelectorAll(
                `[data-variant-dynamic="${id}"]`
              );
              const source = html.querySelector(
                `[data-variant-dynamic="${id}"]`
              );

              if (source && destinations)
                destinations.forEach(
                  (destination, index) =>
                    (destination.innerHTML = source.innerHTML)
                );
            });
          this.productParentElement
            .querySelectorAll(`[data-variant-dynamic]`)
            .forEach((item) => item.classList.remove("opacity-20"));
        });
    }

    handleUnavailableSelects() {
      let selectedButUnavailables = this.fieldsets.reduce(
        (acc = [], fieldset) => {
          let found = [...fieldset.elements].find(
            (input) => input.checked && input.getAttribute("found") === "false"
          );
          if (found) acc.push(found);
          return acc;
        },
        []
      );

      if (!selectedButUnavailables) return;

      selectedButUnavailables.forEach((input) => {
        const availableSibling = [...input.closest("fieldset").elements].find(
          (input) => input.getAttribute("found") !== "false"
        );
        if (!availableSibling) return;
        availableSibling.checked = true;
        this.updateOptions();
      });
    }

    handleAvailabilityStates() {
      if (!this.productButtons) return;

      let available = !this.fieldsets.some((fieldset) =>
        [...fieldset.elements].some(
          (input) =>
            input.checked && input.getAttribute("available") === "false"
        )
      );
      console.log(available, this.fieldsets)
      this.productButtons.forEach((button) =>
        button.setAttribute("available", available)
      );
      this.qtyInput?.setAttribute("available", available);
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector(".variant-json").textContent);
      return this.variantData;
    }

    fetchVariantForm(e) {
      e.preventDefault();
      if (
        e.currentTarget.href.includes(this.productParentElement.dataset.handle)
      ) {
        return;
      }

      fetch(`${e.currentTarget.href}?section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const destination = document.querySelector(
            `[data-section="${this.dataset.section}"]`
          );
          const source = html.querySelector(".shopify-section");

          if (source && destination) {
            source.querySelector;
            destination.innerHTML = source.innerHTML;
            return true;
          } else {
            return false;
          }
        });
    }
  }

  customElements.define("variant-radios", VariantRadios);
}

function findAndReplaceStringInQuotes(originalString, replacementString) {
  // Create a regular expression pattern to match the string inside double quotes
  var regex = /"(.*?)"/g;

  // Use the `replace` method to replace the content inside the double quotes
  var modifiedString = originalString.replace(
    regex,
    '"' + replacementString + '"'
  );

  return modifiedString;
}
